import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(1),
    },
  },
  carregando: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(4),
  },
  card: {
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: '12px',
    boxShadow: 'none',
    margin: theme.spacing(2, 0),
    padding: theme.spacing(2),
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(1.5),
      margin: theme.spacing(1.5, 0),
    },
  },
  divider: {
    margin: theme.spacing(1.5, 0),
  },
  groupCard: {
    paddingTop: theme.spacing(1),
  },
  contentGroupCard: {
    paddingBottom: theme.spacing(2),
  },
  title: {
    fontWeight: 'bold',
    fontSize: '14px',
    color: theme.palette.text.primary,
  },
  subTitle: {
    fontWeight: 'bold',
    fontSize: '12px',
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(0.5),
  },
}))
